import { kEurLong } from 'src/app/shared/utils/k-eur-long';
import { DossierShellMetricProfile } from '../create-dossier-states-definition';
import {
  DossierMetricProfile,
  dossierEconomicParticipantProfile,
  dossierEmployedProfile,
  dossierGvaProfile,
  dossierRevenueProfile,
  dossierTaxedProfile,
} from '../dossier-metric.profile';
import { DashboardDossierStatesOverviewViewConfig } from './dashboard-dossier-states-overview.definition';

/**
 * Overview-shell metric profile: shared dossier metric core +
 * overview view.
 */
export type DossierOverviewMetricProfile = DossierShellMetricProfile<
  DashboardDossierStatesOverviewViewConfig
>;

function fromShared(
  shared: DossierMetricProfile,
  shell: {
    view: DashboardDossierStatesOverviewViewConfig;
  },
): DossierOverviewMetricProfile {
  return {
    ...shared,
    ...shell,
  };
}

export const dossierOverviewTaxedProfile: DossierOverviewMetricProfile =
  fromShared(dossierTaxedProfile, {
    view: {
      metricKey: dossierTaxedProfile.valueLabelKey,
      popupValueLabel: (d: any) => `Anzahl ${d[dossierTaxedProfile.valueLabelKey]}`,
    },
  });

export const dossierOverviewRevenueProfile: DossierOverviewMetricProfile =
  fromShared(dossierRevenueProfile, {
    view: {
      metricKey: dossierRevenueProfile.valueLabelKey,
      metricLabel: 'Umsätze',
      popupValueLabel: (d: any) =>
        `Umsatz von ${d[dossierRevenueProfile.valueLabelKey]}`,
      popupValueFormatter: kEurLong,
    },
  });

export const dossierOverviewGvaProfile: DossierOverviewMetricProfile =
  fromShared(dossierGvaProfile, {
    view: {
      metricKey: dossierGvaProfile.valueLabelKey,
      metricLabel: dossierGvaProfile.base.labels.shortLabel,
      popupValueLabel: (d: any) =>
        d[dossierGvaProfile.valueLabelKey] ?? dossierGvaProfile.base.labels.shortLabel,
      popupValueFormatter: kEurLong,
    },
  });

export const dossierOverviewEconomicParticipantProfile: DossierOverviewMetricProfile =
  fromShared(dossierEconomicParticipantProfile, {
    view: {
      metricKey: dossierEconomicParticipantProfile.valueLabelKey,
      popupValueLabel: (d: any) =>
        `Anzahl ${d[dossierEconomicParticipantProfile.valueLabelKey]}`,
    },
  });

export const dossierOverviewEmployedProfile: DossierOverviewMetricProfile =
  fromShared(dossierEmployedProfile, {
    view: {
      metricKey: dossierEmployedProfile.valueLabelKey,
      popupValueLabel: (d: any) =>
        `Anzahl ${d[dossierEmployedProfile.valueLabelKey]}`,
    },
  });
